<div *ngIf="accountBalanceResponse && !isError">
<header>
  <mat-toolbar class="bg-secondary">
    <mat-toolbar-row class="justify-content-between">
      <a href="https://www.empirxhealth.com" target="_blank"><img src="assets/images/logo.svg" alt="EmpiRx health Logo"
          width="95" /></a>
          <div>
            <!--Banner to show if member is future effective-->
            <div *ngIf="isFutureEffective()" class="header-note d-flex justify-content-start">
              <img class="icon-information" src="assets/images/exclaimation-mark.png" />
              <div>
                {{ multilingualService?.langMap?.LABEL_HEADER_FUTURE_EFFECTIVE_TEXT }}
              </div>
            </div>

            <!--Banner to show client specific message configured-->
            <div *ngIf="clientMessage" class="header-note d-flex justify-content-start">
              <img class="icon-information" src="assets/images/exclaimation-mark.png" />
              <div>
                <span [innerHTML]="clientMessage"></span>
              </div>
            </div>

            <!--Banner to show common header message for all clients-->
            <div *ngIf="commonBannerMessage" class="header-note d-flex justify-content-start">
              <img class="icon-information" src="assets/images/exclaimation-mark.png" />
              <div *ngIf="multilingualService?.langMap">
                <span [innerHTML]="multilingualService.langMap.commonBannerMessage"></span>
              </div>
            </div>
          </div>

      <!-- *ngIf="!isCartPage" -->
      <div class="d-flex">
        <div class="filter mr-2">
          <button
            id="select-font-size"
            mat-icon-button
            #menuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="fontSizeMenu"
            [attr.aria-label]="multilingualService?.langMap?.LABEL_SELECT_TEXT"
          >
            <img
              src="assets/images/font-size.png"
              alt="Font Size"
              width="70px"
              class="font-size-image"
            />
          </button>
          <div class="fliter-dropdown">
             <mat-menu
              #fontSizeMenu="matMenu"
              class="filter-box text-size-dropdown"
            >
              <h4
                (click)="$event.stopPropagation()"
                class="uppercase d-flex justify-content-between text-tertiary lang-dialog-heading"
              >
                <span>{{ multilingualService?.langMap?.LABEL_TEXT_SIZE }}</span>
              </h4>
              <div class="filter-form">
                <mat-radio-group
                  (change)="
                    changeTextSize(this.multilingualService.selectedTextSize)
                  "
                  [(ngModel)]="this.multilingualService.selectedTextSize"
                  [attr.aria-label]="multilingualService?.langMap?.LABEL_SELECT_TEXT"
                  class="d-flex flex-column"
                >
                  <span mat-menu-item>
                    <mat-radio-button value="small">
                      {{ multilingualService?.langMap?.TEXT_SIZE_SMALL }}
                    </mat-radio-button>
                  </span>
                  <span mat-menu-item>
                    <mat-radio-button value="medium"
                      >{{ multilingualService?.langMap?.TEXT_SIZE_MEDIUM }}
                    </mat-radio-button>
                  </span>
                  <span mat-menu-item>
                    <mat-radio-button value="large"
                      >{{ multilingualService?.langMap?.TEXT_SIZE_LARGE }}
                    </mat-radio-button>
                  </span>
                </mat-radio-group>
              </div>
            </mat-menu>
          </div>
        </div>

        <div class="filter mr-3">
          <button id="select-language" mat-icon-button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"
            [attr.aria-label]="multilingualService?.langMap?.SELECT_LANG_LABEL">
            <mat-icon *ngIf="multilingualService?.selectedLang==='en'" class="icon-language-en1"></mat-icon>
            <mat-icon *ngIf="multilingualService?.selectedLang!=='en'" class="icon-language-es1"></mat-icon>
          </button>
          <div class="fliter-dropdown">
            <mat-menu #menu="matMenu" class="filter-box language-dropdown">
              <h4 (click)="$event.stopPropagation()" class="uppercase d-flex justify-content-between text-tertiary lang-dialog-heading">
                <span>{{multilingualService?.langMap?.SELECT_LANGUAGE}}</span>
              </h4>
              <div class="filter-form">
                <mat-radio-group (change)="changeLang(selectedLanguage)" [(ngModel)]="selectedLanguage" aria-label="Select an option"
                  class="d-flex flex-column">
                  <span mat-menu-item >
                    <mat-radio-button value="en">
                      {{multilingualService.langMap?.LABEL_SELECT_LANGUAGE_ENGLISH}}
                    </mat-radio-button>
                  </span>
                  
                  <span mat-menu-item >
                    <mat-radio-button value="es">{{multilingualService.langMap?.LABEL_SELECT_LANGUAGE_SPANISH}}
                    </mat-radio-button>
                  </span>
                  
                </mat-radio-group>
              </div>
            </mat-menu>
          </div>
        </div>

        <ng-container *ngIf="!(this.mailOrderService.disableMailOrderFeatures$ | async)">
          <button routerLink="cart" *ngIf="!isLoggedInMemberTermed && !isLoggedInMemberFutureEffective" mat-icon-button [attr.aria-label]="multilingualService?.langMap?.LABEL_OPEN_CART">
            <mat-icon class="icon-cart" [matBadge]="cartService.prescriptions.length ?cartService.prescriptions.length:null"
              matBadgeColor="warn" aria-hidden="false">
            </mat-icon>
          </button>
        </ng-container>
        
        <div class="filter">
          <button class="mr-0" mat-icon-button [attr.aria-label]="multilingualService?.langMap?.LABEL_OPEN_PROFILE"
            #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu1">
            <mat-icon class="icon-user mr-0"></mat-icon>
          </button>
          <div class="fliter-dropdown user-logout">
            <mat-menu #menu1="matMenu" class="filter-box">
              <div class="d-flex filter-form username-menu">
                <mat-icon class="icon-user"></mat-icon>
                <div class="user-name">
                  <span class="text-w-700 title-8">{{member?.firstName}} {{member?.lastName}}</span>
                  <span class="text-w-300 title-10 d-block">{{member?.cardId}}</span>
                </div>
              </div>
              <!-- <h4 (click)="$event.stopPropagation()"
                class="uppercase no-margin d-flex justify-content-between text-tertiary">
                <span>{{multilingualService?.langMap?.SELECT_MEMBER}}</span>
              </h4> -->
              <div class="filter-form" (click)="$event.stopPropagation()">
                <!-- <mat-list role="list">
                  <mat-list-item *ngFor="let user of familyCoverageResponse?.members || []" role="listitem">
                    <span>
                      <mat-icon class="icon-user"></mat-icon> <span>{{user.firstName}} {{user.lastName}}</span>
                    </span>
                  </mat-list-item>
                </mat-list> -->

                <a mat-menu-item (click)="onLogoutClick()" class="pointer title-11 text-w-700 mb-0 uppercase text-secondary">
                  {{multilingualService?.langMap?.BUTTON_LOGOUT}}
                </a>
              </div>
            </mat-menu>
          </div>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</header>
  <div class="d-flex full-width main-wrapper">
    <!-- *ngIf="!isCartPage" -->
    <div *ngIf="!cartService.isCart" class="relative" [ngClass]="{'close-sidenav': toggleSideNav}">
      <a tabindex="0" [attr.aria-label]="multilingualService?.langMap?.LABEL_COLLAPSE_MENU" class="back-btn" (click)="toggleSideNavfn()">
        <mat-icon class="icon-left-arrow"></mat-icon>
      </a>

      <mat-sidenav-container class="sidenav-container">
        <mat-sidenav #drawer class="sidenav" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
          [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">

          <mat-nav-list>
            <a (click)="closeAll()" mat-list-item [routerLink]="['home']" routerLinkActive="active">
              <mat-icon class="icon-home"></mat-icon> {{multilingualService.langMap?.LABEL_BOTTOM_TABS_HOME}}
            </a>
            <!-- <a (click)="closeAll()" mat-list-item [routerLink]="['orders']" routerLinkActive="active">
              <mat-icon class="icon-orders"></mat-icon> {{multilingualService.langMap?.LABEL_BOTTOM_TABS_ORDERS}}
            </a> -->

            <ng-container *ngIf="!(this.mailOrderService.disableMailOrderFeatures$ | async)">
              <div class="submenu-block" [ngClass]="{'open-submenu': toggleSideNavSubmenuMailOrder}">
                <a tabindex="0" mat-list-item
                  [class.active]="url.includes('settings/address') ||
                url.includes('settings/payment') || url.includes('orders') || url.includes('settings/notifications?smsSetting=false')"
                  (click)="toggleSideNavSubmenuMailfn()"
                  (keydown.enter)="toggleSideNavSubmenuMailfn()">
                  <mat-icon class="icon-orders"></mat-icon>
                  {{multilingualService.langMap?.LABEL_MORE_MAIL_ORDER}}
                  <span class="arrow-icon">
                    <mat-icon class="icon-down-arrow"></mat-icon>
                  </span>
                </a>
                <ul class="submenu" (click)="toggleSideNavSubmenuMailfn()">
                  <li><a [routerLink]="['orders']"
                      routerLinkActive="active">{{multilingualService.langMap?.LABEL_BOTTOM_TABS_ORDERS}}</a>
                  </li>
                  <li><a routerLink="settings/notifications" [queryParams]="{smsSetting: false}"
                      routerLinkActive="active">{{multilingualService.langMap?.LABEL_NOTIFICATIONS}}</a></li>
                  <li><a routerLink="settings/address"
                      routerLinkActive="active">{{multilingualService.langMap?.LABEL_MORE_SETTINGS_SHIPPING_ADDRESS}}</a>
                  </li>
                  <li><a routerLink="settings/payment"
                      routerLinkActive="active">{{multilingualService.langMap?.LABEL_MORE_SETTINGS_PAYMENT_METHODS}}</a>
                  </li>
                </ul>
                <a [matMenuTriggerFor]="menu2" mat-list-item class="setting-menu"
                  [class.active]="url.includes('settings/address') ||
                url.includes('settings/payment') || url.includes('orders') || url.includes('settings/notifications?smsSetting=false')">
                  <mat-icon class="icon-orders"></mat-icon>
                </a>
                <mat-menu #menu2="matMenu">
                  <ul class="sub-menu">
                    <li mat-menu-item><a [routerLink]="['orders']"
                        routerLinkActive="active">{{multilingualService.langMap?.LABEL_BOTTOM_TABS_ORDERS}}</a>
                    </li>
                    <li mat-menu-item><a routerLink="settings/notifications" [queryParams]="{smsSetting: false}"
                        routerLinkActive="active">{{multilingualService.langMap?.LABEL_NOTIFICATIONS}}</a></li>
                    <li mat-menu-item><a routerLink="settings/address"
                        routerLinkActive="active">{{multilingualService.langMap?.LABEL_MORE_SETTINGS_SHIPPING_ADDRESS}}</a>
                    </li>
                    <li mat-menu-item><a routerLink="settings/payment"
                        routerLinkActive="active">{{multilingualService.langMap?.LABEL_MORE_SETTINGS_PAYMENT_METHODS}}</a>
                    </li>
                  </ul>
                </mat-menu>
              </div>
            </ng-container>
            <ng-container  *ngIf="!(this.mailOrderService.disableMailOrderFeatures$ | async)">
              <a (click)="closeAll()" mat-list-item [routerLink]="['prescriptions']" routerLinkActive="active">
                <mat-icon class="icon-prescription"></mat-icon>
                {{multilingualService.langMap?.LABEL_BOTTOM_TABS_PRESCRIPTIONS}}
              </a>
            </ng-container>
            <a (click)="closeAll()" mat-list-item [routerLink]="['drug']" routerLinkActive="active">
              <mat-icon class="icon-drug-search"></mat-icon>
              {{multilingualService.langMap?.LABEL_BOTTOM_TABS_DRUG_SEARCH}}
            </a>
            <a (click)="closeAll()" mat-list-item [routerLink]="['find-pharmacy']" routerLinkActive="active">
              <mat-icon class="icon-find-pharmacy"></mat-icon>
              {{multilingualService.langMap?.LABEL_BOTTOM_TABS_PHARMACY_SEARCH}}
            </a>
            <a (click)="closeAll()" mat-list-item [routerLink]="['claims']" routerLinkActive="active">
              <mat-icon class="icon-claims"></mat-icon>
              {{multilingualService.langMap?.LABEL_BOTTOM_TABS_PHARMACY_CLAIMS}}
            </a>

            <!-- <a (click)="closeAll()" mat-list-item [routerLink]="['clinical-reviews']" routerLinkActive="active">
              <mat-icon class="icon-clinical-review"></mat-icon>
              {{multilingualService.langMap?.LABEL_MORE_CLINICAL_REVIEW}}
            </a> -->
            <div class="submenu-block" [ngClass]="{'open-submenu': toggleSideNavSubmenu1}">
              <a tabindex="0" mat-list-item
                [class.active]="url.includes('clinical-reviews') || url.includes('settings/notifications?smsSetting=true')"
                (keydown.enter)="toggleSideNavSubmenuReviewfn()"
                (click)="toggleSideNavSubmenuReviewfn()">
                <mat-icon class="icon-clinical-review"></mat-icon>
                {{multilingualService.langMap?.LABEL_MORE_CLINICAL_REVIEW}}
                <span class="arrow-icon">
                  <mat-icon class="icon-down-arrow"></mat-icon>
                </span>
              </a>
              <ul class="submenu" (click)="toggleSideNavSubmenuReviewfn()">
                <li><a [routerLink]="['clinical-reviews']" routerLinkActive="active">
                    {{multilingualService.langMap?.LABEL_MORE_CLINICAL_REVIEW_ITEM}}</a>
                </li>
                <li><a routerLink="settings/notifications" [queryParams]="{smsSetting: true}"
                    routerLinkActive="active">{{multilingualService.langMap?.LABEL_NOTIFICATIONS}}</a></li>
              </ul>
              <a [matMenuTriggerFor]="menu3" mat-list-item class="setting-menu"
                [class.active]="url.includes('clinical-reviews') || url.includes('settings/notifications?smsSetting=true')">
                <mat-icon class="icon-clinical-review"></mat-icon>
              </a>
              <mat-menu #menu3="matMenu">
                <ul class="sub-menu">
                  <li mat-menu-item><a [routerLink]="['clinical-reviews']"
                      routerLinkActive="active">{{multilingualService.langMap?.LABEL_MORE_CLINICAL_REVIEW_ITEM}}</a>
                  </li>
                  <li mat-menu-item><a routerLink="settings/notifications" [queryParams]="{smsSetting: true}"
                      routerLinkActive="active">{{multilingualService.langMap?.LABEL_NOTIFICATIONS}}</a></li>
                </ul>
              </mat-menu>
            </div>
            <a (click)="closeAll()" mat-list-item [routerLink]="['membership']" routerLinkActive="active">
              <mat-icon class="icon-membership"></mat-icon>
              {{multilingualService.langMap?.LABEL_BOTTOM_TABS_PHARMACY_MEMBERSHIP}}
            </a>
            <a (click)="closeAll()" mat-list-item [routerLink]="['benefits']" routerLinkActive="active">
              <mat-icon class="icon-benefits"></mat-icon>
              {{multilingualService.langMap?.LABEL_BOTTOM_TABS_PHARMACY_BENEFITS}}
            </a>
            <a (click)="closeAll()" mat-list-item [routerLink]="['forms']" routerLinkActive="active">
              <mat-icon class="icon-form"></mat-icon>{{multilingualService.langMap?.LABEL_FORMS}}
            </a>
            <div class="submenu-block" [ngClass]="{'open-submenu': toggleSideNavSubmenu}">
              <a tabindex="0" mat-list-item [class.active]="url.includes('settings/phi-settings') || toggleSideNavSubmenu" (click)="toggleSideNavSubmenufn()" 
              (keydown.enter)="toggleSideNavSubmenufn()">
                <mat-icon class="icon-settings"></mat-icon>
                {{multilingualService.langMap?.LABEL_BOTTOM_TABS_PHARMACY_SETTINGS}}
                <span class="arrow-icon">
                  <mat-icon class="icon-down-arrow"></mat-icon>
                </span>
              </a>
              <ul (click)="toggleSideNavSubmenufn()" class="submenu">
                <li (click)="settingsOpenUpdateProfile();"><a
                    class="pointer">{{multilingualService.langMap?.LABEL_MORE_SETTINGS_ACCOUNT_PROFILE}}</a></li>
              </ul>
              <a [matMenuTriggerFor]="menu" mat-list-item class="setting-menu" [class.active]="url.includes('settings/phi-settings') || toggleSideNavSubmenu">
                <mat-icon class="icon-settings"></mat-icon>
              </a>
              <mat-menu #menu="matMenu">
                <ul class="sub-menu">
                  <li (click)="settingsOpenUpdateProfile()" mat-menu-item><a
                      class="pointer">{{multilingualService.langMap?.LABEL_MORE_SETTINGS_ACCOUNT_PROFILE}}</a></li>
                </ul>
              </mat-menu>
            </div>
            <div class="submenu-block" [ngClass]="{'open-submenu': toggleSideNavSubmenuHelp}">
              <a tabindex="0" mat-list-item [class.active]="url.includes('help')" (click)="toggleSideNavSubmenuHelpfn()" (keydown.enter)="toggleSideNavSubmenuHelpfn()">
                <mat-icon class="icon-help"></mat-icon> {{multilingualService.langMap?.LABEL_BOTTOM_TABS_PHARMACY_HELP}}

                <span class="arrow-icon">
                  <mat-icon class="icon-down-arrow"></mat-icon>
                </span>
              </a>
              <ul (click)="toggleSideNavSubmenuHelpfn()" class="submenu">
                <li><a routerLink="help/tpa-faq"
                    routerLinkActive="active">{{multilingualService.langMap?.LABEL_FAQS}}</a></li>
                <li><a routerLink="help/privacy-policy"
                    routerLinkActive="active">{{multilingualService.langMap?.LABEL_MORE_PRIVACY_POLICY}}</a></li>
                <li><a routerLink="help/terms-of-use"
                    routerLinkActive="active">{{multilingualService.langMap?.MENU_TERMS_OF_USE}}</a></li>
                <ng-container *ngFor="let link of links">
                  <li (click)="aboutUsClicked()" *ngIf="link.pageName == 'About Us'"><a [href]="link.linkUrl"
                      target="_blank">{{link.pageName === 'About Us'? multilingualService.langMap?.LABEL_ABOUT_US :
                      link.pageName }}</a>
                  </li>
                </ng-container>
                <li><a routerLink="help/support"
                    routerLinkActive="active">{{multilingualService.langMap?.LABEL_MORE_CUSTOMER_SUPPORT}}</a></li>
              </ul>
              <a [matMenuTriggerFor]="menu1" mat-list-item class="setting-menu" [class.active]="url.includes('help')">
                <mat-icon class="icon-help"></mat-icon>
              </a>
              <mat-menu #menu1="matMenu">
                <ul class="sub-menu">
                  <!-- <li mat-menu-item><a routerLink="help/empirx-faq" routerLinkActive="active">EmpiRx FAQ</a></li> -->
                  <li mat-menu-item><a routerLink="help/tpa-faq"
                      routerLinkActive="active">{{multilingualService.langMap?.LABEL_FAQS}}</a></li>
                  <!-- <li><a routerLink="help/about-us" routerLinkActive="active">About Us</a></li> -->
                  <li mat-menu-item><a routerLink="help/privacy-policy"
                      routerLinkActive="active">{{multilingualService.langMap?.LABEL_MORE_PRIVACY_POLICY}}</a></li>
                  <li mat-menu-item><a routerLink="help/terms-of-use"
                      routerLinkActive="active">{{multilingualService.langMap?.MENU_TERMS_OF_USE}}</a></li>
                  <ng-container *ngFor="let link of links">
                    <li (click)="aboutUsClicked()" *ngIf="link.pageName == 'About Us'" mat-menu-item><a
                        [href]="link.linkUrl" target="_blank">{{link.pageName === 'About Us'?
                        multilingualService.langMap?.LABEL_ABOUT_US : link.pageName }}</a></li>
                  </ng-container>
                  <li mat-menu-item><a routerLink="help/support"
                      routerLinkActive="active">{{multilingualService.langMap?.LABEL_MORE_CUSTOMER_SUPPORT}}</a></li>
                </ul>
              </mat-menu>
            </div>
            <a mat-list-item (click)="onLogoutClick()">
              <mat-icon class="icon-shutdown"></mat-icon> {{multilingualService.langMap?.BUTTON_LOGOUT}}
            </a>
          </mat-nav-list>
        </mat-sidenav>

      </mat-sidenav-container>
    </div>
    <!-- Add Content Here -->
    <router-outlet></router-outlet>
  </div>
</div>

<div class="backdrop" *ngIf="!(accountBalanceResponse) && !isError">
  <img class="loader" src="../../../../assets/images/loader.gif" alt="Loader" width="60px" />
</div>

<div *ngIf="isError" class="empty-box-height box-height auto-margin flex-column">
  <!-- Sorry, something went wrong -->
  <img aria-hidden="true" src="../../../assets/images/wrong.svg" alt="{{errorMsg}}" width="75px" />
  <p role="alert" class="title-11 text-w-700 mt-1"> {{errorMsg}}</p>
  <div class="center mt-3 pt-1">
    <button (click)="logout()" mat-raised-button
      class="primary-button uppercase">{{multilingualService.langMap?.BUTTON_LOGOUT}}</button>
  </div>
</div>


<ng-template #error>
  <div class="toaster-bg error d-flex justify-content-center">
    <mat-icon class="icon-error mr-1"></mat-icon>
    <span>Something went wrong</span>
  </div>
</ng-template>
<ng-template #success>
  <div class="toaster-bg success d-flex justify-content-center">
    <mat-icon class="icon-success mr-1"></mat-icon>
    <span>{{multilingualService.langMap?.LABEL_UPDATE_PROFILE_SUCCESS_MSG}}</span>
  </div>
</ng-template>
<ng-template #updateProfileError>
  <div class="toaster-bg error d-flex justify-content-center">
    <mat-icon class="icon-error mr-1"></mat-icon>
    <span>{{errorMsgForUpdateProfile}}</span>
  </div>
</ng-template>